import request from "@/utils/requestCustom";

let quickwordApi = {
  // 获取列表
  getList(query) {
    return request({
      url: "/account/reply/allList",
      method: "get",
      params: query,
    });
  },
  //新增
  addWord(data) {
    return request({
      url: "/account/reply",
      method: "post",
      data: data,
    });
  },
  //编辑
  editWord(data) {
    return request({
      url: "/account/reply",
      method: "put",
      data,
    });
  },
  //删除
  delWord(id) {
    return request({
      url: "/account/reply/" + id,
      method: "delete",
    });
  },

  // 置顶
  topWord(data) {
    return request({
      url: "/account/reply/setUp",
      method: "put",
      data,
    });
  },

  // 获取系统字典
  getDict() {
    return request({
      url: "/system/dict/data/type/replyConfig",
      method: "get",
    });
  }
};
export default quickwordApi;
